import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Alert } from 'reactstrap';
// Local Deps
import './ToolingLocationsForm.scss';
import msgs from '../../../config/messages';
import formConfig from './formConfig';
// Form Builder
import Form from '../../FormBuilder';
import { isUSZipCode, isCanadianZipCode } from '../../FormBuilder/validators';
import ZipCode from '../../FormBuilder/CustomInputs/ZipCode';

class ToolingLocationForm extends React.Component {
  static initialState = {
    fields: {
      ...formConfig,
    },
    flashMessage: '',
  };

  state = ToolingLocationForm.initialState;

  _onStateFieldChange = (field, value) => {
    if (field !== 'country') return;
    const zipCode = {};
    let stateHidden;
    let provinceHidden;
    if (value === 'United States of America') {
      zipCode.helpBlock = 'Please enter a 5 or 9 digit ZIP Code';
      zipCode.validators = [isUSZipCode];
      zipCode.componentClass = ZipCode('american');
      zipCode.displayName = 'ZIP Code';
      stateHidden = false;
      provinceHidden = true;
    } else if (value === 'Canada') {
      zipCode.helpBlock = 'Please enter a valid postal code';
      zipCode.validators = [isCanadianZipCode];
      zipCode.componentClass = ZipCode('canadian');
      zipCode.displayName = 'Postal Code';
      stateHidden = true;
      provinceHidden = false;
    }
    // Update State
    this.setState(oldState => ({
      fields: {
        ...oldState.fields,
        state: {
          ...oldState.fields.state,
          hidden: stateHidden,
        },
        zipCode: {
          ...oldState.fields.zipCode,
          ...zipCode,
        },
        province: {
          ...oldState.fields.province,
          hidden: provinceHidden,
        },
      },
    }));
  };

  _handleSubmit = async (e, formValues) => {
    e.preventDefault();
    const submissionValues = {};
    Object.entries(formValues).forEach(([fieldName, value]) => {
      if (
        fieldName === 'province' &&
        formValues.country.toLowerCase() !== 'canada'
      ) {
        return;
      }
      if (
        fieldName === 'state' &&
        formValues.country.toLowerCase() !== 'united states of america'
      ) {
        return;
      }
      submissionValues[fieldName] = value;
    });
    try {
      this.setState({
        flashMessageType: 'success',
        flashMessage: 'Thank you for your submission!',
      });
      await Promise.all([
        axios.post(
          `${process.env.REACT_APP_API_HOST}/toolings`,
          submissionValues,
        ),
        sleep(2000),
      ]);
      this.props.history.push('/');
    } catch (err) {
      this.setState({
        flashMessageType: 'danger',
        flashMessage:
          'There was an error with your submission. Please try again in a couple minutes.',
      });
      console.error(err);
      await sleep(3000);
      this.setState({
        flashMessageType: '',
        flashMessage: '',
      });
    }
  };

  render() {
    const { flashMessage, flashMessageType } = this.state;

    // Configure Form fields
    const configuredFields = {
      ...this.state.fields,
      state: {
        ...this.state.fields.state,
        fieldChangeHandler: this._onStateFieldChange,
      },
    };

    return flashMessage ? (
      <Alert color={flashMessageType}>{flashMessage}</Alert>
    ) : (
      <div className="nf-tooling-locations-form">
        <div className="nf-tooling-locations-form__body">
          {/* <!-- TEXT --> */}
          <div className="nf-tooling-locations-form__text-block">
            {msgs.Tooling.text}
          </div>
          <div className="nf-tooling-locations-form__text-block">
            {msgs.Tooling.text2}
          </div>
          {/* <!-- FORM --> */}
          <Form
            className="nf-tooling-locations-form__form"
            onSubmit={this._handleSubmit}
            fields={Object.values(configuredFields)}
          />
        </div>
      </div>
    );
  }
}

ToolingLocationForm.propTypes = {
  history: PropTypes.object.isRequired,
};

function sleep(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}
export default ToolingLocationForm;



// WEBPACK FOOTER //
// ./src/components/ToolingLocations/ToolingLocationsForm/ToolingLocationsForm.jsx